import React from 'react';
import { Box, List, ListItemButton, ListItemText, ListItemIcon, Collapse, Typography, Chip } from '@mui/material';
import { ExpandLess, ExpandMore, Category as CategoryIcon } from '@mui/icons-material';
import useCategories from '../hooks/useCategories';

function CategoryItem({ category, selectedCategory, onCategoryChange, level = 0 }) {
  const [open, setOpen] = React.useState(false);
  const hasChildren = category.children && category.children.length > 0;

  const handleClick = () => {
    if (hasChildren) {
      setOpen(!open);
    }
    onCategoryChange(category.id === selectedCategory ? null : category.id);
  };

  return (
    <>
      <ListItemButton
        selected={category.id === selectedCategory}
        onClick={handleClick}
        sx={{ pl: 2 + level * 2 }}
      >
        <ListItemIcon>
          <CategoryIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={category.name} />
        {hasChildren && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
      {hasChildren && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {category.children.map((child) => (
              <CategoryItem
                key={child.id}
                category={child}
                selectedCategory={selectedCategory}
                onCategoryChange={onCategoryChange}
                level={level + 1}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

export default function CategoryFilter({ selectedCategory, onCategoryChange }) {
  const { categoryTree, isLoading } = useCategories();

  if (isLoading) {
    return <Typography>Loading categories...</Typography>;
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Categories</Typography>
        {selectedCategory && (
          <Chip
            label="Clear"
            size="small"
            onDelete={() => onCategoryChange(null)}
          />
        )}
      </Box>
      <List component="nav">
        {categoryTree.map((category) => (
          <CategoryItem
            key={category.id}
            category={category}
            selectedCategory={selectedCategory}
            onCategoryChange={onCategoryChange}
          />
        ))}
      </List>
    </Box>
  );
}
